import { ENVIRONMENT } from 'constants/environment';
import type { Building } from 'types/configurations';
import type { Area, AssetType } from 'types/project';

type GetPlanImage = {
  area: Area;
  displayName: string;
  planName?: string;
  building: Building;
  assetTypology?: AssetType;
};

export const getPlanImage = ({ area, displayName, planName, building, assetTypology }: GetPlanImage) => {
  const BUCKET_PROJECT_PATH = `${ENVIRONMENT.REACT_APP_BUCKET_BASEURL}/initiatives/${encodeURI(displayName || '')}`;
  if (assetTypology === 'room') {
    return `${BUCKET_PROJECT_PATH}/planimetry/${encodeURI(building?.complex)}/room/${planName}.png`;
  }
  if (area === 'rent') {
    // Apartment plans on rent projects are stored under the building folder (complex preferred, fallback to name)
    const folder = building?.complex || building?.name;
    return `${BUCKET_PROJECT_PATH}/planimetry/${encodeURI(folder || '')}/${planName}.png`;
  }
  return `${BUCKET_PROJECT_PATH}/floorplanning/img/planimetrie/${planName}.png`;
};
